<app-header></app-header>
<ion-content class="customContainer">
  <ion-grid class="subHeader">
    <ion-row class="ion-justify-content-around ion-align-items-center sub-head">
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-toolbar mode="md">
          <ion-buttons slot="start">
            <ion-back-button defaultHref="/home"></ion-back-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-col>
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-searchbar mode="md" placeholder="{{'Searchforproductname'|language:'Search for product name'}}"
          [debounce]="500" (ionChange)="searchProduct($event)" [(ngModel)]="searchText" #search>
        </ion-searchbar>
      </ion-col>
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-item lines="none" class="addCatalog">
          <ion-buttons slot="end">
            <ion-icon name="reload-outline" class="refresh" color="primary" (click)="getMerchantDetails()"></ion-icon>
          </ion-buttons>
          <ion-buttons slot="end">
            <ion-button (click)="optionsMenu()">
              <ion-icon name="ellipsis-vertical"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div *ngIf="shopStatus && shopStatus !== 'open'" class="closed-shop">
    <img src="./assets/images/Frame 8816.svg" alt="" />
  </div>
  <ng-container>
    <div class="boxx">
      <div class="innerbox">
        <div class="left ">
          <div class="hometitle">
            <img src="./assets/home.svg" alt="load">
            <div class="shopNameRating">
              <p>{{vendorDetails?.shop_name | titlecase}}</p>
              <div size="12" class="ratingStar">
                <ion-icon [src]="customerRating >= 1 
                  ? '/assets/images/ratingPage/akar-icons_star_yellow.svg' 
                  : '/assets/images/ratingPage/akar-icons_star.svg'">
                </ion-icon>
                <ion-icon [src]="customerRating >= 2 
                  ? '/assets/images/ratingPage/akar-icons_star_yellow.svg' 
                  : '/assets/images/ratingPage/akar-icons_star.svg'">
                </ion-icon>
                <ion-icon [src]="customerRating >= 3 
                  ? '/assets/images/ratingPage/akar-icons_star_yellow.svg' 
                  : '/assets/images/ratingPage/akar-icons_star.svg'">
                </ion-icon>
                <ion-icon [src]="customerRating >= 4 
                  ? '/assets/images/ratingPage/akar-icons_star_yellow.svg' 
                  : '/assets/images/ratingPage/akar-icons_star.svg'">
                </ion-icon>
                <ion-icon [src]="customerRating >= 5 
                  ? '/assets/images/ratingPage/akar-icons_star_yellow.svg' 
                  : '/assets/images/ratingPage/akar-icons_star.svg'">
                </ion-icon>
              </div>
            </div>
          </div>
          <p *ngIf="!deliveryStatus" class="custom-paragraph">
            {{'Notdeliveringatyourcurrentlocation'|language:'Not delivering at your current location'}}
          </p>
        </div>
        <div class="right ">
          <p>
            <a [href]="'tel:'+vendorDetails?.seller.phone">
              <ion-img
                src="{{vendorDetails?.seller.image?vendorDetails?.seller.image:'/assets/Login-Img/gg_profile@2x.svg'}}"
                alt="profilepic"> </ion-img>
            </a>
          </p>
        </div>
      </div>
      <div class="custom-div">
        <ion-segment no-padding [value]="selectedCategory" class="custom-segment" mode="md" [scrollable]="true"
          *ngIf="vendorDetails?.store_meta[0]?.url">
          <ion-segment-button [value]="i" *ngFor="let category of vendorDetails?.dataList?.catalog; let i = index"
            (click)="selectedCategory = i; selectedSubCategory = 0; selectedMicroCategory = 1">
            <span [ngClass]="selectedCategory == i ? 'selectedCategory active' : 'selectedCategory'">
              {{category?.id|language:category.name}}
            </span>
          </ion-segment-button>
        </ion-segment>
      </div>
    </div>
    <ion-row class="sub-nav">
      <ng-container
        *ngIf="vendorDetails?.dataList?.catalog[this.selectedCategory]?.categories[this.selectedSubCategory]?.categories?.length > 0; else elseBlock">
        <ion-col class="sub-nav-btn" size="4" size-sm="4" size-md="4" size-lg="4" *ngFor="let item of vendorDetails?.dataList?.catalog[this.selectedCategory]?.categories[this.selectedSubCategory]?.categories; 
            let microCategoryIndex = index" (click)="selectedMicroCategory = microCategoryIndex + 1"
          [ngClass]="{'class_sub-nav-btn': microCategoryIndex == selectedMicroCategory - 1}">
          <p class="capitalize">{{item?.id ? (item?.id | language : item.name) : item.name}}</p>
        </ion-col>
      </ng-container>

      <ng-template #elseBlock>
        <ion-col class="sub-nav-btn class_sub-nav-btn" size="4" size-sm="4" size-md="4" size-lg="4"
          *ngIf="vendorDetails?.dataList?.catalog[this.selectedCategory]">
          <p class="capitalize">{{'all' | language: 'All'}}</p>
        </ion-col>
      </ng-template>
    </ion-row>
    <div *ngIf="vendorDetails?.dataList?.catalog?.length" class="filter-container ">
      <div class="filters">
        <ion-list class="list" lines="none ">
          <ion-grid>
            <ion-row>
              <ion-col class="ion-align-self-start" size="2" size-sm="1">
                <div class="side-row-parent">
                  <ion-row class="sideRow">
                    <ion-col size="12" class="sideCol"
                      *ngFor="let item of vendorDetails?.dataList?.catalog[selectedCategory]?.categories; let i = index"
                      [ngClass]="{'selected': i == selectedSubCategory}"
                      (click)="selectedSubCategory = i; selectedMicroCategory = 1">
                      <ion-img class="imgslide" alt=""
                        [src]="(item.image === '' || !item.image) ? 'assets/icon/categories-fallbackimage.svg' : item.image"></ion-img>
                      <p class="capitalize">{{item?.id ? (item?.id | language : item.name) : item.name}}</p>
                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
              <ion-col class="ion-align-self-start" size="10">
                <ion-row style="margin-left : 5px; margin-right : 5px" *ngIf="selectedMicroCategory">
                  <ng-container *ngFor="let item of getCurrentProducts()">
                    <ion-col style="padding: 5px;" size="6" size-sm="4"
                      *ngIf="searchText ? item.prdNm.toLowerCase().includes(searchText.toLowerCase()) : true">
                      <div class="card-box">
                        <div class="slide-image ">
                          <span
                            [ngClass]="item.status?.trim().toLowerCase() == 'published' && shopStatus == 'open' ? 'wpd-sale-badge' : 'idDisabled wpd-sale-badge'"
                            *ngIf="item.price.preOrdDisc && item.price.preOrdDisc != 0">{{'PreOrder' |
                            language:'Preorder'}}
                            {{item?.price?.preOrdDisc}}% {{'Off' |language: 'Off'}} </span>
                          <ion-img
                            [ngClass]="item.status?.trim().toLowerCase() == 'published' && shopStatus == 'open' ? 'imgslide' : 'idDisabled imgslide'"
                            alt="" [src]="item.media?.img1" onerror="this.onerror = null; this.src=''"></ion-img>
                          <div class="heart" *ngIf="item?.status === 'published' && item.popularity">
                            <ion-img src="assets/images/popular-icon.png"></ion-img>
                          </div>
                        </div>
                      </div>
                      <div class="slide-sub ">
                        <div class="up">
                          <div style="display:flex;">
                            <p class="item-name">{{item?.id | language : item.prdNm}}</p>
                            <ion-img *ngIf="itemsInCart.includes(item.id)" style="height: 18px;"
                              src="/assets/images/completed.svg"></ion-img>
                          </div>
                          <p class="price" *ngIf="item.status?.trim().toLowerCase() != 'published'">
                            {{item?.price?.mrp ? item?.price?.mrp : 0 | currency : 'INR' : 'symbol' : '0.0-2'}} /
                            {{'kg' | language : 'kg'}}
                          </p>
                        </div>
                        <div class="Qua-Add">
                          <button class="quantity"
                            (click)="item.status?.trim().toLowerCase() == 'published' && shopStatus == 'open' ? quantity(item) : ''"
                            [disabled]="addDisable">
                            <p>
                              {{ item?.quantity?.minQty === null ? 1 : item?.quantity?.minQty }}
                              {{ item?.status?.trim().toLowerCase() === 'published'
                              ? (item?.quantity?.soldBy | language: item?.quantity?.soldBy)
                              : 'Kg'}}
                            </p>
                            <ion-icon name="chevron-down-outline" style="color: black;"></ion-icon>
                          </button>
                          <button
                            [ngClass]="item.status?.trim().toLowerCase() == 'published' && shopStatus == 'open' ? '' : 'idDisabled'"
                            (click)="item.status?.trim().toLowerCase() == 'published' && shopStatus == 'open' ? selectDate(item, true) : ''"
                            [disabled]="addDisable">{{'add' | language : 'Add'}}
                          </button>
                        </div>
                      </div>
                    </ion-col>
                  </ng-container>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-list>
      </div>
    </div>
    <app-empty-list *ngIf="flag"></app-empty-list>
  </ng-container>
</ion-content>
<div class="cart" *ngIf="cartData?.cart?.length" (click)="navigateToCart()">
  <span>{{cartData.totalProducts}} {{'items'|language:'Items '}}</span>
  <button class="viewCart">{{'viewCart' | language:'View Cart'}}</button>
</div>